export function stickElement(element) {
    const rect = element.getBoundingClientRect();
    Object.assign(element.style, {
        position: 'fixed',
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        right: `${rect.right - rect.width}px`,
    });
    return () => {
        Object.assign(element.style, { position: '', top: '', left: '', right: '' });
    };
}
//# sourceMappingURL=stickElement.js.map